class ZetaItemApi extends ZetaApi {
  #path = "api/item";
  #totalCount = 0;
  #facet;
  #items;
  #limit = 96;
  #unit = 0;
  #offset = 0;
  #page = 1;
  #sort = "-score";
  #isFasetAcquisition = false;
  // zeta apiのかけ合わせコレクション名用パラメータ
  // https://zero-start.backlog.jp/alias/wiki/524972#__wiki_header_11
  #collectionname;

  constructor() {
    super();
    super.endPoint = this.#path;
  }

  async request() {
    this.#defaultParams();
    const response = await super.request();
    this.#setData(response);
  }

  get totalCount() {
    return this.#totalCount;
  }

  get limit() {
    return this.#limit;
  }

  get facetList() {
    this.#facet.subcategory = this.facetSubCategory;
    return this.#facet;
  }

  get facetCategory() {
    return this.#facet.category;
  }

  get facetSubCategory() {
    let list = [];
    if (this.#facet.category) {
      for (let category of this.#facet.category) {
        list = list.concat(category.category2);
      }
    }
    return list;
  }

  get facetBrand() {
    return this.#facet.brand;
  }

  get facetSaleType() {
    return this.#facet.saletype;
  }

  get items() {
    return this.#items;
  }

  set itemLimit(limit) {
    this.#limit = limit;
  }

  set isFasetAcquisition(flg) {
    this.#isFasetAcquisition = flg;
  }

  set collectionname(cn) {
    this.#collectionname = cn;
  }

  #defaultParams() {
    this.deleteInsertParam("l", this.getParam("l") ?? this.#limit);
    this.deleteInsertParam("u", this.getParam("u") ?? this.#unit);
    this.deleteInsertParam("o", this.#getOffset());
    this.deleteInsertParam("s", this.#getSort());
    this.deleteParams("p");
    if (this.#isFasetAcquisition) {
      this.deleteInsertParam("c", "brand,category,sale_type");
    }
    if(this.#collectionname){
      this.deleteInsertParam("collectionname", this.#collectionname);
    }
  }

  #getOffset() {
    const p = this.getParam("p") || ["1"];
    const page = Number(p[0]) || this.#page;
    if (page == 1) return this.#offset;
    const limit = this.getParam("l");
    return (page - 1) * limit[0];
  }

  #getSort() {
    const c = this.getParam("collection");
    const s = this.getParam("s");

    if (c && (!s || s[0] == this.#sort)) {
      return `collectionorder,${this.#sort}`;
    }

    if (!s || s[0] == this.#sort) {
      return this.#sort;
    }

    const arr = this.decodeValue(s[0]).split(",");
    return `${arr[0]},${this.#sort}`;
  }

  #setData(response) {
    //const meta = response.meta;

    if (response === undefined) return false;

    const result = response.result;
    this.#totalCount = result.attribute.total;
    this.#facet = result.facet;
    this.#items = result.items;
  }
}
